import { useSendUserPhotoMutation } from './hooks';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { ImageInputComponent } from 'components/layout/initializers/image-input-component';
import { InlineSvg } from 'components/svg';
import _ from 'lodash';
import { FC, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { toAbsoluteUrl } from 'utils/assets';

export const PublicUploadEmployeePhotoForm: FC = () => {
  const [file, setFile] = useState(undefined);
  const { userId: uid } = useParams();
  const editBtnRef = useRef<HTMLLabelElement>(null);
  const { mutate: uploadPhoto } = useSendUserPhotoMutation();
  const employee = { imageUrl: '' };

  const handleImageChange = (event: any) => {
    const { files } = event.target;
    const file = files[0];
    setFile(file);
  };

  useEffect(() => {
    const imageObject = ImageInputComponent.createInsance('#kt_image_input_control');
    imageObject!.on('kt.imageinput.changed', handleImageChange);
  }, []);

  const handleSubmit = () => {
    uploadPhoto({ uid: uid!, photo: file! });
  };

  return (
    <div className={styles.page}>
      <div className="mt-3">
        <img
          alt="Logo"
          src={toAbsoluteUrl('/media/logos/default-dark.svg')}
          className={`theme-dark-show h-45px ${styles.logo}`}
        />
        <img
          alt="Logo"
          src={toAbsoluteUrl('/media/logos/default.svg')}
          className={`theme-light-show h-45px ${styles.logo}`}
        />

        <div className={`my-5 ${styles.headerSeparator}`}></div>
      </div>

      <div className={styles.mainContainer}>
        <div>
          <div className={styles.sectionsContainer}>
            <div className={styles.sectionsWrapper}>
              <div className={styles.leftSection}>
                <div className={`fs-1 fw-bold ${styles.pageTitle}`}>
                  <span>Upload Photo</span>
                </div>

                <div className="fs-4">Please make or upload photo for your profile.</div>
                <div className="fs-4">Follow recommendations listed below:</div>

                <div className={`fs-2 ${styles.recomendationsTitle}`}>Recommendations</div>

                <ul className={styles.list}>
                  <li>
                    <span>Make photo behind white wall</span>
                  </li>
                  <li>
                    <span>Make sure that the place where you make photo has enough light</span>
                  </li>
                  <li>
                    <span>Your face should be in center of your photo</span>
                  </li>
                  <li>
                    <span>Slightly smile</span>
                  </li>
                </ul>
              </div>

              <div className={styles.rightSection}>
                <div className={`fs-2 ${styles.exampleTitle}`}>Good Example</div>

                <div
                  className={clsx('image-input w-300px h-300px', !employee?.imageUrl && 'image-input-empty')}
                  style={{ backgroundImage: `url(${toAbsoluteUrl('/media/avatars/example.png')})` }}
                >
                  <div className="image-input-wrapper w-300px h-300px"></div>
                </div>
              </div>
            </div>
          </div>

          {!file && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                editBtnRef?.current?.click();
              }}
            >
              <InlineSvg path="/media/icons/duotune/general/picture.svg" className="svg-icon-2" />
              Upload Photo
            </button>
          )}

          <div className={clsx(!file && 'd-none')}>
            <div className="separator my-10"></div>

            <div className={`fs-2 ${styles.yourPhotoTitle}`}>Your Photo</div>

            <div className={`${styles.sectionsContainer} ${styles.lowerSectionsContainer}`}>
              <div className={styles.sectionsWrapper}>
                <div className={styles.leftSection}>
                  <div
                    id="kt_image_input_control"
                    className={clsx('image-input', !employee?.imageUrl && 'image-input-empty', styles.userImage)}
                    data-kt-image-input="true"
                  >
                    <div
                      className="image-input-wrapper w-300px h-300px cursor-pointer"
                      onClick={() => {
                        editBtnRef?.current?.click();
                      }}
                    ></div>
                    <label
                      className="d-none btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                      data-kt-image-input-action="change"
                      data-bs-toggle="tooltip"
                      title="Change avatar"
                      ref={editBtnRef}
                    >
                      <i className="bi bi-pencil-fill fs-7"></i>

                      <input type="file" name="avatar" accept=".png, .jpg, .jpeg" />
                      <input type="hidden" name="avatar_remove" />
                    </label>
                  </div>
                </div>

                <div className={styles.rightSection}>
                  <div className={styles.submitBtnsContainer}>
                    <button
                      type="button"
                      className={`btn btn-secondary ${styles.submitBtnItem}`}
                      onClick={() => {
                        editBtnRef?.current?.click();
                      }}
                    >
                      <InlineSvg path="/media/icons/duotune/general/picture.svg" className="svg-icon-2" />
                      Change photo
                    </button>

                    <button onClick={handleSubmit} className={`btn btn-primary ${styles.submitBtnItem}`} type="button">
                      Send this photo
                    </button>

                    <ToastContainer autoClose={2000} theme="light" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
